// extracted by mini-css-extract-plugin
module.exports = {"container":"HoverLimit_container__GpZsx","show":"HoverLimit_show__3CzKz"};